import React from 'react';

import { SearchBox } from 'react-instantsearch-dom';

const Submit = (
    <svg viewBox="0 0 48 48">
        <path d="M20.5 6C12.51 6 6 12.51 6 20.5S12.51 35 20.5 35c3.46 0 6.63-1.22 9.13-3.25l9.8 9.81a1.5 1.5 0 1 0 2.13-2.12l-9.81-9.81A14.43 14.43 0 0 0 35 20.5C35 12.51 28.49 6 20.5 6zm0 3a11.48 11.48 0 0 1 8.3 19.47 1.5 1.5 0 0 0-.33.32A11.48 11.48 0 0 1 9 20.5c0-6.36 5.13-11.49 11.5-11.49z" />
    </svg>
);

const Reset = (
    <svg viewBox="0 0 48 48">
        <path d="M39.49 6.98a1.5 1.5 0 0 0-1.05.46L24 21.88 9.56 7.44a1.5 1.5 0 0 0-1.08-.46 1.5 1.5 0 0 0-1.04 2.58L21.88 24 7.44 38.44a1.5 1.5 0 1 0 2.12 2.12L24 26.12l14.44 14.44a1.5 1.5 0 1 0 2.12-2.12L26.12 24 40.56 9.56a1.5 1.5 0 0 0-1.07-2.58z"/>
    </svg>
);

const SearchField = () => (
    <SearchBox
        className="search-field"
        searchAsYouType={true}
        showLoadingIndicator={false}
        submit={Submit}
        reset={Reset}
        translations={{
            submitTitle: 'Zoeken',
            resetTitle: 'Reset',
            placeholder: 'Naam of beschrijving',
        }}
    />
);

export { SearchField };
